import { postRequest } from "./postRequest";

const CallReview_API = process.env.REACT_APP_CALL_REVIEW

console.log("API URL:", CallReview_API);
export const postCallReview = (payload) => {


  return postRequest(CallReview_API, payload);
};

/**
 * Render the review email without sending it.
 *
 * Deliberately the same endpoint and payload as a real send, with
 * `previewOnly` set: the backend builds the message through the code path that
 * would have sent it and returns the markup instead. Rebuilding the template
 * here would drift from the real email the moment either side changed, and a
 * preview that lies is worse than no preview.
 *
 * Nothing is written — previewing a review must not count as reviewing it.
 *
 * @returns {Promise<{subject:string, html:string, to:string[], cc:string[]}>}
 */
export const previewCallReviewEmail = (payload) =>
  postRequest(CallReview_API, { ...payload, previewOnly: true, sendEmail: false });
